<template>
  <section>
    <Modal v-if="showModal && !hasCookies" @closeModal="closeModal" />
    <SideBar
      @closeSideBar="toggleSideBar"
      v-if="sideBarOpen"
      :links="content.navigation"
      data-aos="fade-right"
    />
    <NavBar
      @toggleSideBar="toggleSideBar"
      :sideBarOpen="sideBarOpen"
      :links="content.navigation"
      :backgroundColor="backgroundColour"
      :is-home-page="true"
      :textColor="textColour"
      :logo="
        $isMobile()
          ? require('../assets/images/Nav_House.png')
          : require(`../assets/images/${logoType}.png`)
      "
      data-aos="fade-down"
    />
    <div class="hero">
      <video class="hero__video" autoplay loop muted>
        <source src="../assets/images/hero-video-2024.mp4" type="video/mp4" />
      </video>
    </div>
    <h1 class="hero__title">
      {{ content.hero.title }}
    </h1>
    <div class="razor"></div>
    <div class="assets">
      <div class="assets__left">
        <div class="assets__left--text" data-aos="fade-right">
          <h3>{{ content.assets.title }}</h3>
          <img
            class="assets__left--title icon"
            src="../assets/images/arrow-white.svg"
          />
          <p>{{ content.assets.body }}</p>
        </div>
        <img class="assets__left--chicken" src="../assets/images/chicken-home.png" />
        <img
          class="assets__left--sushi"
          src="../assets/images/sushi.png"
          data-aos="fade-up"
        />
      </div>
      <div class="assets__right">
        <img
          class="assets__right--taco"
          src="../assets/images/taco-yellow.png"
          data-aos="fade-left"
        />
        <img
          class="assets__right--phone"
          src="../assets/images/iPhone-2024.png"
          data-aos="fade-up"
        />
        <img
          class="assets__right--woman"
          src="../assets/images/courier-7.png"
          data-aos="fade-left"
        />
      </div>
    </div>
    <div class="logos-hero" id="logos">
      <h1 class="logos-hero__title" data-aos="zoom-in">
        {{ content.logos.title }}
      </h1>
    </div>
    <div class="logos-types">
      <div class="logos-types__intro">
        <div class="logos-types__intro--left" data-aos="fade-right">
          <h4>{{ content.logos.subtitle }}</h4>
        </div>
        <div class="logos-types__intro--right" data-aos="fade-left">
          <p>
            <span>{{ content.logos.global_title }}</span>
            {{ content.logos.global }}
          </p>
          <p>
            <span>{{ content.logos.corporate_title }}</span>
            {{ content.logos.corporate }}
          </p>
        </div>
      </div>
      <div v-if="!$isMobile()" class="logos-types__tiles">
        <a
          class="tile"
          v-for="(tile, i) in content.logos.tiles"
          href="https://s3.eu-west-1.amazonaws.com/brand-box.marketing.just-eat.com/downloads/jet-logos.zip"
          target="_blank"
          download
          :key="i"
          :style="`width: ${tile.width}%`"
          :data-aos="tile.animation"
        >
          <img :src="require(`../assets/images/${tile.image}.png`)" />
        </a>
      </div>
      <div v-if="$isMobile()" class="logos-types__tiles">
        <div
          class="tile"
          v-for="(tile, i) in content.logos.mobile_tiles"
          :key="i"
          :style="`width: ${tile.width}%`"
          :data-aos="tile.animation"
        >
          <img :src="require(`../assets/images/${tile.image}.png`)" />
          <h4>{{ tile.text }}</h4>
        </div>
      </div>
    </div>
    <div class="logos-rules">
      <div class="logos-rules__intro">
        <div class="logos-rules__intro--left" data-aos="fade-right">
          <h4>{{ content.logos.box_title }}</h4>
          <p>{{ content.logos.box_body }}</p>
        </div>
        <div class="logos-rules__intro--right" data-aos="fade-left">
          <img src="../assets/images/pad-thai.png" />
        </div>
      </div>
      <div class="logos-rules__columns" data-aos="fade-up">
        <div class="logos-rules__columns--left" data-aos="fade-right">
          <h3>{{ content.logos.do.title }}</h3>
          <ul>
            <li v-for="(item, i) in content.logos.do.list" :key="i">
              <div class="accordian" @click="toggleDoResult(i)">
                <img class="accordian__icon" src="../assets/images/yes.svg" />
                <p>{{ item.instruction }}</p>
                <img
                  class="accordian__icon"
                  :src="
                    require(`../assets/images/${
                      doResult === i ? 'down' : 'up'
                    }-arrow.svg`)
                  "
                />
              </div>
              <img
                class="accordian-image"
                v-if="doResult === i"
                :src="require(`../assets/images/${item.result}.png`)"
              />
            </li>
          </ul>
        </div>
        <div class="logos-rules__columns--right" data-aos="fade-left">
          <h3>{{ content.logos.dont.title }}</h3>
          <ul>
            <li v-for="(item, i) in content.logos.dont.list" :key="i">
              <div class="accordian" @click="toggleDontResult(i)">
                <img class="accordian__icon" src="../assets/images/no.svg" />
                <p>{{ item.instruction }}</p>
                <img
                  class="accordian__icon"
                  :src="
                    require(`../assets/images/${
                      dontResult === i ? 'down' : 'up'
                    }-arrow.svg`)
                  "
                />
              </div>
              <img
                class="accordian-image"
                v-if="dontResult === i"
                :src="require(`../assets/images/${item.result}.png`)"
              />
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="colours-hero" id="colours">
      <div
        class="colours-hero__dots"
        v-for="(dot, i) in content.colours.dots"
        :key="i"
      >
        <div
          ref="dot"
          :id="`dot_${i}`"
          class="colours-hero__dots--dot"
          :class="dot.class"
          @click="updateChosenDot(i)"
        ></div>
      </div>
      <div
        v-if="chosenDot !== false"
        class="colours-hero__dots--info"
        :style="`border-top: 30px solid #${
          content.colours.dots[chosenDot].details[3].code
        }; top: ${chosenTop}px; left: ${chosenLeft + 130}px;`"
      >
        <div class="detail-title">
          <h5>{{ content.colours.dots[chosenDot].name }}</h5>
          <p>{{ content.colours.dots[chosenDot].type }}</p>
        </div>
        <div
          v-for="(detail, i) in content.colours.dots[chosenDot].details"
          :key="i"
          class="detail-grid"
        >
          <p>{{ detail.name }}</p>
          <input type="text" :value="detail.code.toUpperCase()" />
        </div>
      </div>
      <h1 class="colours-hero__title">
        {{ content.colours.title }}
      </h1>
    </div>
    <div class="colours-ratios">
      <div class="colours-ratios__intro">
        <div
          v-if="!$isMobile()"
          class="colours-ratios__intro--left"
          data-aos="fade-right"
        >
          <img src="../assets/images/color-palette.png" />
        </div>
        <div v-else class="colours-ratios__intro--left" data-aos="fade-right">
          <h4>{{ content.colours.palette_title }}</h4>
          <img src="../assets/images/color-palette-mobile.png" />
        </div>
        <div class="colours-ratios__intro--right" data-aos="fade-left">
          <h4>{{ content.colours.ratios.title }}</h4>
          <h5>{{ content.colours.ratios.subtitle }}</h5>
          <p>{{ content.colours.ratios.body_1 }}</p>
          <p>{{ content.colours.ratios.body_2 }}</p>
          <ul>
            <li v-for="(item, i) in content.colours.ratios.list" :key="i">
              {{ item }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="press-hero" id="press">
      <h1 class="press-hero__title" data-aos="zoom-in">
        {{ content.press.title }}
      </h1>
    </div>
    <div class="press-images">
      <div class="press-images__intro">
        <div class="press-images__intro--left" data-aos="fade-right">
          <h4>{{ content.press.images_title }}</h4>
        </div>
        <div class="press-images__intro--right" data-aos="fade-left">
          <p>{{ content.press.images_body }}</p>
        </div>
      </div>
      <div class="press-images__tiles">
        <div
          v-for="(column, i) in content.press.sections"
          :key="i"
          data-aos="fade-up"
          class="press-images__tiles--columns"
        >
          <a
            :href="`https://s3.eu-west-1.amazonaws.com/brand-box.marketing.just-eat.com/downloads/${column.link}.zip`"
            target="_blank"
            download
          >
            <img
              class="image"
              :src="require(`../assets/images/${column.image}.png`)"
            />
            <h5 v-if="!$isMobile()">
              <img
                :src="
                  require(`../assets/images/${
                    $isMobile() ? 'link' : 'download'
                  }.svg`)
                "
              />
              {{ column.name }}
            </h5>
          </a>
        </div>
      </div>
    </div>
    <div class="presentation-hero" id="presentations">
      <h1 class="presentation-hero__title" data-aos="zoom-in">
        {{ content.presentation.title }}
      </h1>
    </div>
    <div class="presentation-example">
      <div class="presentation-example__intro">
        <div class="presentation-example__intro--left" data-aos="fade-right">
          <h4>{{ content.presentation.example_title_1 }}</h4>
          <h4>{{ content.presentation.example_title_2 }}</h4>
        </div>
        <div class="presentation-example__intro--right" data-aos="fade-left">
          <p>{{ content.presentation.example_body }}</p>
          <a
            class="light button"
            href="https://s3.eu-west-1.amazonaws.com/brand-box.marketing.just-eat.com/downloads/jet-presentations.zip"
            target="_blank"
            download
          >
            {{
              $isMobile()
                ? content.presentation.button_dark_mobile
                : content.presentation.button_dark
            }}
          </a>
          <!-- <a
            v-if="!$isMobile()"
            class="light button"
            href="https://docs.google.com/presentation/d/1h9cqw7gns-I0imW5Sqp4KCBQrkeRRNwI7ofQLqv5MyY/edit#slide=id.gb96b01cec0_0_53"
            target="_blank"
          >
            {{ content.presentation.button_light }}
          </a> -->
        </div>
      </div>
    </div>
    <div class="outro">
      <img
        class="outro__laptop"
        :src="
          require(`../assets/images/laptop.png`)
        "
      />
      <div class="outro__details" data-aos="fade-up">
        <h2 class="outro__details--title">
          {{ content.outro.title }}
        </h2>
        <p class="outro__details--body">
          {{ content.outro.body }}
        </p>
        <a class="outro__details--button light button" href="/more">
          {{
            authState.isAuthenticated
              ? content.outro.button_light_alt
              : content.outro.button_light
          }}
        </a>
      </div>
      <img
        class="outro__tacos"
        src="../assets/images/cookies.png"
        data-aos="fade-left"
      />
    </div>
    <div class="footer">
      <p class="footer__body">
        {{ content.footer.body_1
        }}<a
          class="footer__body--link"
          :href="`mailto:${content.footer.link_1}`"
          target="_blank"
          >{{ content.footer.link_1 }}</a
        >{{ content.footer.body_2 }}
      </p>
      <p class="footer__body">
        {{ content.footer.body_3
        }}<a
          class="footer__body--link"
          :href="content.footer.url"
          target="_blank"
          >{{ content.footer.link_2 }}</a
        >
      </p>
    </div>
  </section>
</template>

<script>
import NavBar from '../components/NavBar'
import SideBar from '../components/SideBar'
import Modal from '../components/Modal'
import Content from '../data/content'
import JQuery from 'jquery'
const $ = JQuery

export default {
  name: 'Home',
  components: {
    NavBar,
    SideBar,
    Modal,
  },
  data() {
    return {
      content: Content.home,
      doResult: false,
      dontResult: false,
      chosenDot: false,
      chosenLeft: false,
      chosenTop: false,
      sideBarOpen: false,
      scrollHeight: false,
      showModal: true,
    }
  },
  computed: {
    getArrowImage() {
      return this.showResult
        ? require(`../assets/images/down-arrow.svg`)
        : require(`../assets/images/up-arrow.svg`)
    },
    isOrange() {
      if (
        (this.scrollHeight >= 0 && this.scrollHeight < 936) ||
        (this.scrollHeight >= 4800 && this.scrollHeight < 5510)
      ) {
        return true
      }
      return false
    },
    textColour() {
      return this.isOrange ? 'orange' : 'orange'
    },
    backgroundColour() {
      return this.isOrange ? 'white' : 'white'
    },
    logoType() {
      if (this.scrollHeight >= 0 && this.scrollHeight < 816)
        return 'Nav_Logo'
      return this.isOrange ? 'Nav_House' : 'Nav_House'
    },
    hasCookies() {
      return (
        this.$cookie.get('cookies-accepted') !== null &&
        this.$cookie.get('terms-accepted') !== null
      )
    },
  },
  mounted() {
    this.animateDivs()
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  watch: {
    chosenDot(to, from) {
      if (to === false || to === from) {
        this.animateDivs()
      } else {
        this.stopAnimate()
      }
    },
  },
  methods: {
    makeNewPosition() {
      const h = $(window).height() - 50
      const w = $(window).width() - 50
      const nh = Math.floor(Math.random() * h)
      const nw = Math.floor(Math.random() * w)
      return [nh, nw]
    },
    animateDivs() {
      this.content.colours.dots.forEach((dot, i) => {
        const newq = this.makeNewPosition()
        const self = this
        $(`#dot_${i}`).animate({ top: newq[0], left: newq[1] }, 8000, () => {
          self.animateDivs()
        })
      })
    },
    stopAnimate() {
      this.content.colours.dots.forEach((dot, i) => $(`#dot_${i}`).stop(true))
    },
    handleScroll(event) {
      this.scrollHeight = event.target.documentElement.scrollTop
    },
    toggleDoResult(i) {
      this.doResult = i
    },
    toggleDontResult(i) {
      this.dontResult = i
    },
    updateChosenDot(i) {
      this.chosenLeft = parseInt($(`#dot_${i}`).css('left'))
      this.chosenTop = parseInt($(`#dot_${i}`).css('top'))
      this.chosenDot === i ? (this.chosenDot = false) : (this.chosenDot = i)
    },
    toggleSideBar(val) {
      this.sideBarOpen = val
    },
    closeModal() {
      this.showModal = false
    },
  },
}
</script>

<style lang="scss" >
$desktop: 1024px;
$tablet: 768px;
$mobile: 600px;

section {
  background-color: var(--color-mozzarella-1);
}

.pizza,
.milkshake {
  position: absolute;
}

.milkshake {
  width: 200px;
  left: 300px;
  margin-top: -100px;
  transform: rotate(340deg);
  @media (max-width: $tablet) {
    left: 2%;
    margin-top: -120px;
    transform: rotate(340deg);
  }
}

.pizza {
  width: 300px;
  left: -4%;
  @media (max-width: $tablet) {
    margin-top: -120px;
    left: 25%;
  }
}

.hero {
  &__title {
    color: var(--color-white-1);
    text-align: center;
    margin: -1000px 0 400px;
    position: relative;
    @media (max-width: $tablet) {
      margin: -1100px 0 300px;
    }
  }
}
.razor {
  background-color: var(--color-orange-1);
  clip-path: polygon(0% 0%, 100% 0%, 100% 50%, 0% 100%);
  height: 900px;
  @media (max-width: $tablet) {
    height: 650px;
  }
}
.assets {
  width: 60%;
  position: sticky;
  margin-top: -750px;
  z-index: 2;
  display: flex;
  padding: 50px 20% 150px;
  align-items: flex-start;
  background-color: var(--color-mazzarella-1);
  @media (max-width: $tablet) {
    width: 90%;
    padding: 20px 5%;
    margin-top: -650px;
  }
  &__left {
    width: 50%;
    &--text {
      padding: 0 0 50px 0;
      color: var(--color-white-1);
      width: 70%;
      img {
        fill: var(--color-white-1);
        width: 40px;
      }
      p {
        width: 85%;
        color: var(--color-white-1);
      }
      h3 {
        color: var(--color-white-1);
      }
    }
    &--chicken {
      width: 100%;
      border-radius: 30px;
      z-index: -1;
    }
    &--sushi {
      width: 40%;
      margin-top: 100px;
      @media (max-width: $tablet) {
        margin-top: 20px;
      }
    }
  }
  &__right {
    width: 50%;
    &--taco {
      width: 120%;
      max-width: 400px;
      @media (max-width: $tablet) {
        margin-top: 95px;
      }
    }
    &--phone {
      width: 100%;
      margin-left: -25%;
      margin-top: -100px;
      z-index: 1;

      @media (max-width: $tablet) {
        margin-top: -22px;
        width: 112%;
      }
    }
    &--woman {
      width: 60%;
      border-radius: 30px;
      z-index: -1;
      position: relative;
      margin-left: -190px;
      @media (max-width: $tablet) {
        width: 80%;
        margin-left: 20px;
        margin-top: 20px;
      }
    }
  }
}
.logos-hero {
  width: 100%;
  background-image: url('../assets/images/women.jpg');
  display: inline-block;
  background-size: cover;
  background-position: center;
  &__title {
    background: linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(0,0,0,0.23295255602240894) 30%, rgba(60,60,60,0.23015143557422968) 70%, rgba(255,255,255,0) 100%);
    margin: 400px 0;
    text-align: center;
    color: var(--color-white-1);
  }
}
.logos-types {
  width: 100%;
  background-color: var(--color-orange-1);
  clip-path: polygon(0% 0%, 100% 0%, 100% 70%, 0% 100%);
  padding: 160px 0;
  @media (max-width: $tablet) {
    clip-path: polygon(0% 0%, 100% 0%, 100% 70%, 0% 100%);
  }
  &__intro {
    display: flex;
    margin: 0 10%;
    justify-content: center;
    align-items: flex-start;
    padding: 50px 0;
    @media (max-width: $tablet) {
      flex-direction: column;
      margin: 0 10% 20px;
      padding: 50px 0 20px;
    }
    &--left,
    &--right {
      width: 40%;
      h4,
      p,
      span {
        margin: 20px 0;
        color: var(--color-white-1);
      }
      @media (max-width: $tablet) {
        width: 90%;
      }
    }
  }
  &__tiles {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 50px 0 250px;
    align-items: flex-start;
    @media (max-width: $tablet) {
      width: 100%;
      padding: 10px 0 250px;
    }
    .tile {
      margin: 1%;
      cursor: pointer;
      @media (max-width: $tablet) {
        margin: 0 5%;
      }
      img {
        width: 100%;
        display: block;
        &:hover {
          opacity: 0.9;
          transform: scale(1.02);
        }
      }

      h4 {
        color: var(--color-white-1);
        text-align: center;
        font-family: 'JETSans-Regular', sans-serif;
      }
    }
  }
}
.logos-rules {
  width: 100%;
  background-color: var(--color-mozzarella-1);
  padding: 0 0 160px;
  &__intro {
    display: flex;
    margin: 0 10%;
    justify-content: center;
    align-items: center;
    margin-top: -200px;
    position: sticky;
    align-items: flex-end;
    @media (max-width: $tablet) {
      flex-direction: column-reverse;
    }
    &--right {
      width: 70%;
      img {
        width: 100%;
        @media (max-width: $tablet) {
          width: 500px;
          margin-left: -100px;
        }
      }
    }
    &--left {
      width: 30%;
      border-radius: 30px;
      padding: 20px 50px;
      h4,
      p {
        margin: 20px 0;
        color: var(--color-charcoal-1);
      }
      @media (max-width: $tablet) {
        width: 80%;
        margin: 50px 2.5%;
        padding: 10%;
      }
    }
  }
  &__columns {
    display: flex;
    margin: 0 10%;
    justify-content: space-evenly;
    align-items: center;
    @media (max-width: $tablet) {
      flex-direction: column;
      margin: 0 5%;
    }
    &--left,
    &--right {
      width: 40%;
      border-radius: 30px;
      -webkit-box-shadow: rgba(17, 17, 26, 0.1) 0px 4px 16px,
        rgba(17, 17, 26, 0.05) 0px 8px 32px;
      -moz-box-shadow: rgba(17, 17, 26, 0.1) 0px 4px 16px,
        rgba(17, 17, 26, 0.05) 0px 8px 32px;
      box-shadow: rgba(17, 17, 26, 0.1) 0px 4px 16px,
        rgba(17, 17, 26, 0.05) 0px 8px 32px;
      @media (max-width: $tablet) {
        width: 100%;
      }
      .accordian {
        justify-content: space-between;
        display: flex;
        height: 100px;
        align-items: center;
        font-weight: 900;
        cursor: pointer;
        &__icon {
          width: 40px;
        }
        img {
          margin: 0 20px;
        }
      }
      .accordian-image {
        width: 100%;
      }
      h3 {
        padding: 15px 25px;
        border-radius: 30px 30px 0 0;
        margin: 0;
      }
      ul {
        list-style: none;
        color: var(--color-charcoal-1);
        padding: 0;
      }
    }
    &--left {
      margin-top: 50px;
      h3 {
        color: var(--color-white-1);
        background-color: var(--color-orange-1);
      }
    }
    &--right {
      margin-top: 250px;
      @media (max-width: $tablet) {
        margin-top: 50px;
      }
      h3 {
        color: var(--color-white-1);
        background-color: var(--color-tomato-1);
      }
    }
  }
}
.colours-hero {
  width: 100%;
  background-image: url('../assets/images/katy-perry.png');
  display: inline-block;
  position: relative;
  background-size: cover;
  background-position: top;
  background-repeat: no-repeat;
  cursor: url('../assets/images/color-picker.svg'), auto;
  &__title {
    background: linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(0,0,0,0.23295255602240894) 30%, rgba(60,60,60,0.23015143557422968) 70%, rgba(255,255,255,0) 100%);
    text-align: center;
    color: var(--color-white-1);
    margin: 400px 0;
    z-index: -1;
  }
  &__dots {
    transform: translateZ(0);
    position: relative;
    @media (max-width: $tablet) {
      display: none;
    }
    &--dot {
      height: 120px;
      width: 120px;
      border-radius: 50%;
      position: fixed;
      border: 2px solid var(--color-white-1);
      z-index: 0;
      &:hover {
        opacity: 0.9;
        transform: scale(1.02);
      }
    }
    &--info {
      width: 200px;
      height: 240px;
      border-radius: 30px;
      background-color: var(--color-mozzarella-3);
      display: flex;
      flex-wrap: wrap;
      align-content: center;
      padding: 5px 15px;
      position: absolute;
      cursor: text;
      z-index: 1;
      .detail-title {
        display: block;
        margin: 0 0 20px;
      }
      .detail-grid {
        width: 50%;
        p {
          font-size: 10px;
        }
      }
      h5,
      p {
        margin: 5px 0;
        color: var(--color-charcoal-1);
      }
      p:first-child {
        margin-bottom: 10px;
      }
      input {
        width: 85px;
        border: 1px solid var(--color-mozzarella-1);
        border-radius: 30px;
        background-color: var(--color-mozzarella-1);
        padding: 5px;
        font-size: 10px;
        color: var(--color-charcoal-1);
        font-family: 'JETSans-Regular', sans-serif;
        text-align: center;
      }
    }
  }
}
.colours-ratios {
  width: 100%;
  background-color: var(--color-mozzarella-2);
  @media (max-width: $tablet) {
    padding-bottom: 0;
    padding-top: 20px;
  }
  &__intro {
    display: flex;
    margin: 0 10% 0 0;
    -webkit-box-pack: center;
    justify-content: space-between;
    -webkit-box-align: start;
    align-items: flex-end;
    padding: 160px 0;
    align-items: center;
    @media (max-width: $tablet) {
      display: flex;
      -webkit-box-pack: center;
      -webkit-box-align: start;
      align-items: center;
      padding: 50px 0;
      flex-direction: column;
      margin: 0;
    }

    &--left,
    &--right {
      h4,
      p {
        margin: 20px 0;
        color: var(--color-charcoal-1);
      }
      img {
        width: 100%;
        border-radius: 30px;
      }
      ul {
        list-style: none;
        padding: 0;
        li {
          font-weight: 600;
          margin: 5px 0;
          color: var(--color-charcoal-1);
        }
      }
    }
    &--left {
      width: 50%;
      margin-left: 5%;
      @media (max-width: $tablet) {
        margin-left: 0;
        width: 80%;
        h4 {
          margin: 20px 0 50px;
        }
      }
    }
    &--right {
      width: 40%;
      @media (max-width: $tablet) {
        width: 80%;
        h4 {
          margin: 50px 0 20px;
        }
      }
    }
  }
}
.press-hero {
  width: 100%;
  background-image: url('../assets/images/BTL_sRGB_2023_Winter-Warmers_Parmigiana_Macro.png');
  background-color: var(--color-orange-1);
  display: inline-block;
  background-position: inherit;
  background-size: cover;
  &__title {
    background: linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(0,0,0,0.23295255602240894) 30%, rgba(60,60,60,0.23015143557422968) 70%, rgba(255,255,255,0) 100%);
    text-align: center;
    color: var(--color-white-1);
    margin: 280px 0;
  }
}
.press-images {
  width: 100%;
  background-color: var(--color-mozzarella-3);
  &__intro {
    display: flex;
    margin: 0 10%;
    padding: 160px 0 0;
    -webkit-box-pack: center;
    -webkit-box-align: start;
    align-items: center;
    justify-content: center;
    @media (max-width: $tablet) {
      flex-direction: column;
    }
    &--left,
    &--right {
      width: 35%;
      h4,
      h5,
      p {
        color: var(--color-charcoal-1);
      }
      h4 {
        margin: 20px 0 10px;
      }
      @media (max-width: $tablet) {
        width: 90%;
      }
    }
  }
  &__tiles {
    display: flex;
    margin: 0 10%;
    padding: 0 0 160px;
    @media (max-width: $tablet) {
      flex-wrap: wrap;
    }

    &--columns {
      margin: 70px 1%;
      width: 23%;
      .image {
        width: 100%;
        cursor: pointer;
        border-radius: 20px;
        -webkit-box-shadow: rgba(17, 17, 26, 0.1) 0px 4px 16px,
          rgba(17, 17, 26, 0.05) 0px 8px 32px;
        -moz-box-shadow: rgba(17, 17, 26, 0.1) 0px 4px 16px,
          rgba(17, 17, 26, 0.05) 0px 8px 32px;
        box-shadow: rgba(17, 17, 26, 0.1) 0px 4px 16px,
          rgba(17, 17, 26, 0.05) 0px 8px 32px;
        &:hover {
          opacity: 0.9;
          transform: scale(1.02);
        }
      }
      a {
        text-decoration: none;
      }
      h5 {
        text-align: center;
        font-size: 18px;
        img {
          width: 25px;
          margin: -5px 10px;
        }
      }
      @media (max-width: $tablet) {
        width: 46%;
        margin: 10px 2%;
      }
    }
  }
}
.presentation-hero {
  width: 100%;
  display: inline-block;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url('../assets/images/Lifestyle_H_RGB_Global_2022_RestaurantAwards_PokePrep.png');

  &__title {
    background: linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(0,0,0,0.50) 30%, rgba(60,60,60,0.50) 70%, rgba(255,255,255,0) 100%);
    text-align: center;
    color: var(--color-white-1);
    margin: 400px 0;
    @media (max-width: $tablet) {
      font-size: 60px;
    }
  }
}
.presentation-example {
  width: 100%;
  background-color: var(--color-mozzarella-1);
  clip-path: polygon(0 0, 100% 0%, 100% 100%, 0 85%);
  padding-bottom: 400px;
  @media (max-width: $tablet) {
    padding-bottom: 150px;
    clip-path: polygon(0 0, 100% 0%, 100% 100%, 0 95%);
  }
  &__intro {
    display: flex;
    margin: 0 20%;
    justify-content: center;
    align-items: flex-start;
    padding-top: 160px;
    align-items: center;
    @media (max-width: $tablet) {
      flex-direction: column;
    }
    &--left,
    &--right {
      width: 40%;
      @media (max-width: $tablet) {
        width: 90%;
      }
      h4,
      p {
        margin: 10px 0;
        color: var(--color-charcoal-1);
      }
      h4 {
        @media (max-width: $tablet) {
          margin-bottom: 10px;
          margin: 0;
        }
      }
      p {
        @media (max-width: $tablet) {
          margin-bottom: 40px;
        }
      }
      .light {
        background-color: transparent;
        color: var(--color-charcoal-1);
      }
      a {
        font-size: 16px;
        margin: 10px;
        display: inline-flex;
        border: 2px solid var(--color-charcoal-1);
        cursor: pointer;
        padding: 10px 15px;
        justify-content: center;
        img {
          width: 20px;
          margin-right: 5px;
        }
        @media (max-width: $tablet) {
          margin: 10px 0;
        }
      }
    }
  }
}
.outro {
  width: 100%;
  background-color: var(--color-orange-1);
  margin-top: -100px;
  padding: 0 10%;
  width: 80%;
  &__laptop {
    text-align: center;
    width: 80%;
    display: flex;
    margin: 0 10% 200px;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    margin-top: -350px;
    position: sticky;
    @media (max-width: $tablet) {
      width: 100%;
      margin: -130px 0 80px 40px;
    }
  }
  &__details {
    text-align: center;
    &--title,
    &--body {
      color: var(--color-white-1);
      margin: 20px 0;
      padding: 0px 15%;
      @media (max-width: $tablet) {
        padding: 0px 5%;
      }
    }
    &--body {
      margin-bottom: 50px;
    }
    &--button {
      border: 2px solid var(--color-white-1);
    }
    .dark {
      background-color: transparent;
      color: var(--color-white-1);
    }
    .light {
      background-color: var(--color-white-1);
      color: var(--color-orange-1);
    }
  }
  &__tacos {
    width: 65%;
    margin-bottom: -5px;
    margin-left: 60%;
    position: relative;
    @media (max-width: $tablet) {
      width: 115%;
      margin-left: 50px;
    }
  }
}
.footer {
  padding: 40px 10%;
  background-color: var(--color-mozzarella-1);
  &__body {
    text-align: center;
    color: var(--color-charcoal-1);
    &--link {
      color: var(--color-charcoal-1);
      font-weight: 600;
    }
  }
}
</style>